export const REPORT_VERSION_STATUSES = [
    "waiting",
    "pending",
    "processing",
    "completed",
    "failed",
] as const;

export type ReportVersionStatus = (typeof REPORT_VERSION_STATUSES)[number];

export const REPORT_REFUSAL_CODES = [
    "reports_not_enabled",
    "document_not_found",
    "extraction_not_applicable",
    "extraction_failed",
    "no_extracted_policy_type",
    "duplicate_document",
    "no_renewal_document",
    "duplicate_policy_type_in_role",
    "no_comparable_policy_type",
    "role_period_mismatch",
    "mixed_clients",
    "too_many_documents",
    "definition_not_found",
    "report_already_requested",
    "instruction_not_found",
] as const;

export const REPORT_RETRY_REFUSAL_CODES = [
    "report_in_progress",
    "report_not_retryable",
    "retry_limit_reached",
] as const;

export type ReportRetryErrorCode =
    | (typeof REPORT_REFUSAL_CODES)[number]
    | (typeof REPORT_RETRY_REFUSAL_CODES)[number];

export const REPORT_NOT_FOUND_DETAIL = "Report not found";

/**
 * The backend stores notes without their null fields and types them as open
 * mappings, so every field but `code` may be absent. Every text field is
 * untrusted plain text.
 */
export interface IReportNoteProblem {
    code: string;
    document_id?: number | null;
    detail?: string | null;
}

export interface IReportNote {
    code: string;
    detail?: string | null;
    document_id?: number | null;
    unit_id?: string | null;
    problems?: IReportNoteProblem[] | null;
}

export interface IReportVersionSummary {
    id: number;
    report_id: number;
    version_number: number;
    chat_message_id: number | null;
    operation: "create" | "revise";
    status: ReportVersionStatus;
    waiting_document_ids: number[] | null;
    failure_code: string | null;
    document_id: number | null;
    artifact_available: boolean;
    notes: IReportNote[];
    notes_total: number;
    created_at: string;
    updated_at: string;
}
